import { gql } from 'apollo-boost';

import { ValidationErrorFragment, ValidationWarningFragment } from './common';

export const updateAdGroup = gql`
    mutation UpdateAdGroup(
        $textInput: GdUpdateTextAdGroupInput!
        $smartInput: GdUpdatePerformanceAdGroupInput!
        $login: String!
    ) {
        reqId: getReqId
        updateTextAdGroup(input: $textInput) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        updateSmartAdGroups(input: $smartInput) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const addSmartFilters = gql`
    mutation AddSmartFilters($input: GdAddSmartFiltersInput!, $login: String!) {
        reqId: getReqId
        addSmartFilters(input: $input) {
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const deleteSmartFilters = gql`
    mutation DeleteSmartFilters(
        $input: GdDeleteSmartFilterInput!
        $login: String!
    ) {
        reqId: getReqId
        deleteFilters(input: $input) {
            deletedItems {
                id
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
`;

export const updateSmartFilters = gql`
    mutation UpdateSmartFilters(
        $input: GdUpdateSmartFiltersInput!
        $login: String!
    ) {
        reqId: getReqId
        updateFilters(input: $input) {
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
            updatedItems {
                id
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const createTextAdGroup = gql`
    mutation CreateTextAdGroup(
        $textInput: GdAddTextAdGroupItemInput!
        $login: String!
    ) {
        reqId: getReqId
        addTextAdGroups(input: { addItems: [$textInput] }) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const createSmartAdGroup = gql`
    mutation CreateSmartAdGroup(
        $smartInput: GdAddSmartAdGroupItemInput!
        $login: String!
    ) {
        reqId: getReqId
        addSmartAdGroups(input: { addItems: [$smartInput] }) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const updateInternalGroup = gql`
    mutation updateInternalAdGroups(
        $internalInput: GdUpdateInternalAdGroupsInput!
    ) {
        reqId: getReqId
        updateInternalAdGroups(input: $internalInput) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const remoderateAdsCalloutsMutation = gql`
    mutation RemoderateAdsCallouts(
        $input: GdRemoderateAdsCalloutsInput!
        $login: String!
    ) {
        reqId: getReqId
        remoderateAdsCallouts(input: $input) {
            processedAdGroupIds
            skippedAdGroupIds
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const addInternalGroups = gql`
    mutation addInternalAdGroups($internalInput: GdAddInternalAdGroupsInput!) {
        reqId: getReqId
        addInternalAdGroups(input: $internalInput) {
            addedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const copyAdGroupsMutation = gql`
    mutation CopyAdGroupsMutation(
        $input: GdCopyAdGroupsInput!
        $login: String!
    ) {
        copyAdGroups(input: $input) {
            copiedAdGroupIds
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }

                warnings {
                    ...ValidationWarningFragment
                }
            }
        }

        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const updateCpmAdGroup = gql`
    mutation UpdateCpmAdGroup(
        $cpmInput: GdUpdateCpmAdGroupInput!
        $login: String!
    ) {
        reqId: getReqId
        saveCpmAdGroups(input: $cpmInput) {
            updatedAdGroupItems {
                adGroupId
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;
